<template>
  <div>
    <div class="select-filter pb2 mb1">
      <div :class="headerClass" class="option-all" @click="expanded=!expanded">
        <div class="flex">
          <div class="flex-auto">
            <span class="ml1">{{label}}:</span>
            <span v-if="!expanded && selected" class="bold pl2">{{items[selected].label}}</span>
          </div>
          <div class="mr1">
            <span style="text-align: right;">&#9660;</span>
          </div>
        </div>
      </div>
      <div v-if="expanded || !selected" style="border: 1px solid #dfe1e5; border-top: none;">
        <template v-for="itemId in listItems">
          <div v-if="show==null || itemId in show" :key="itemId">
            <a @click="selectItem(itemId)" :class="checkClass(itemId)">
              {{items[itemId].label}}
            </a>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupSelector',
  components: { },
  props: {
    headerClass: null,
    label: null,
    listItems: null, // if list of items
    items: null,
    show: null,
    filters: Object,
    selected: null, // current value
  },

  data() {
    return {
      expanded: false,
    };
  },

  created() {
  },

  computed: {
  },

  methods: {
    selectItem(itemId) {
      this.$emit('itemClick', itemId);
      this.expanded = false;
    },
    checkClass(code) {
      return this.filters[code] ? 'filter-selected' : 'filter-one-unselected';
    },
  },
};
</script>

<style>
  .select-filter {
    font-size:12px;
    line-height: 16px;
    /* border-left: 2px solid #94C232; */
  }
  .select-filter div {
    padding: 2px 8px;

    cursor: pointer;
    font-family: Tahoma;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.04em;
    color: #000000;
  }
  .select-filter div.option-all {
    opacity: 0.8;
    padding: 14px 8px;
    border-radius: 4px;
  }

  .filter-selected {
    font-weight: bold;
  }

  .filter-one-unselected::before {
    content: "○";
    font-weight: bold;
    font-size: 1.1em;
    vertical-align: bottom;
  }
  /* ☑ ☒ */
  .filter-selected::before {
    content: "✓";
    font-weight: bold;
    font-size: 1.1em;
    vertical-align: bottom;
  }

</style>
